import {
    createHandlerChainRunner,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ApiResultModel, getRoleBasePages } from "@tecumseh/Services/RoleBasePageService";
import { CustomApiHandler } from "@tecumseh/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface Parameter {
    onSuccess?: (results: ApiResultModel) => void;
}

type HandlerType = CustomApiHandler<Parameter, ApiResultModel>;

export const BeginLoading: HandlerType = props => {
    props.dispatch({
        type: "Custom/RoleBasePage/BeginFetchingContents",
    });
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await getRoleBasePages();
};

export const RequestCompleted: HandlerType = props => {
    props.dispatch({
        type: "Custom/RoleBasePage/SetContents",
        contentResults: props.apiResult
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const CompletedLoading: HandlerType = props => {
    props.dispatch({
        type: "Custom/RoleBasePage/CompletedFetchingContents",
    });
};

export const chain = [BeginLoading, SendDataToApi, RequestCompleted, ExecuteOnSuccessCallback, CompletedLoading];

const getRoleBaseWebsitePages = createHandlerChainRunner(chain, "GetRoleBaseWebsitePages");
export default getRoleBaseWebsitePages;
